export const stageConfigs = {
  zIndex: '1',
  containerId: 'canvas-container-jedi',
};
